import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center text-sm text-gray-lp-300 pt-2 font-normal" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "text-red-lp-100 underline",
  href: "mailto:system@thelionparcel.com"
}, " system@thelionparcel.com ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.t("setupPassword.helpWA")) + " ", 1),
    _createVNode("a", {
      class: "text-red-lp-100 underline",
      href: `https://wa.me/${_ctx.cleanPhoneNumber('085180763985')}`,
      target: "_blank"
    }, " 0851-8076-3985 ", 8, ["href"]),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.t("setupPassword.helpEmail")) + " ", 1),
    _hoisted_3
  ]))
}